<template>
  <div id="app-wrapper" class="min-h-screen transition-colors duration-300 bg-white text-ink-900 dark:bg-ink-950 dark:text-ink-100">
    <router-view />
  </div>
</template>

<script setup>
  
</script>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root {
  color-scheme: light;
}
:root.dark {
  color-scheme: dark;
}
</style>